import * as React from 'react';
import {connect} from 'react-redux';

import {openReplyModal} from '../email-reply-actions';

type DispatchProps = {
    openModal: (replyToEmailId: string) => void;
};

type Props = DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        openModal: (replyToEmailId: string) => {
            dispatch(openReplyModal({replyToEmailId}));
        },
    };
}

export const TimelineEmailReplyListenerComponent = (props: Props) => {
    React.useEffect(() => {
        $(window).on(Nut.View.events.ReplyWasClicked, handleReplyWasClicked);

        return () => {
            $(window).off(Nut.View.events.ReplyWasClicked, handleReplyWasClicked);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleReplyWasClicked = (
        e: any,
        data: {
            emailId: string;
        }
    ) => {
        props.openModal(data.emailId);
    };

    return null;
};

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(null, mapDispatchToProps);
export const TimelineEmailReplyListener = connector(TimelineEmailReplyListenerComponent);
